import { AchieveLink } from 'components/AchieveLink'
import styles from './NavPills.module.scss'
import { Typography } from 'components/Contentful'
import { getStrictValueContenfullRichText } from 'utils/shared'

function NavPills({ content, activeSection = 0, setActiveSection, trackData }) {
  if (!content?.length > 0) return

  return (
    <div className={styles['nav-articles-list']}>
      {content?.map((item, index) => {
        const title = getStrictValueContenfullRichText(item.title)
        const link = item.link

        return (
          <div
            key={`item-nav-articles-${index}`}
            className={styles['nav-articles-item-cotainer']}
            onClick={() => setActiveSection(index)}
          >
            <div className={styles['nav-articles-item']} data-active={activeSection === index}>
              <AchieveLink
                href={link}
                track={{
                  list_name: 'Breadcrumb',
                  click_text: `${title}`,
                  click_id: `${title}`,
                  click_position: '0',
                  nav_link_section: 'Breadcrumb',
                  track_event: 'page_nav_click',
                  event_action: 'link_click',
                  event_type: 'link_click',
                  ...trackData,
                }}
                underline="hover"
                color="inherit"
                noLink={!link}
                data-testid={`nav-pill-item-link-${index}`}
              >
                <Typography content={title} variant="labelSm" data-testid="nav-pill-item-text" />
              </AchieveLink>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export { NavPills }
